export enum OTPChannel {
  E = 'E',
  S = 'S',
}
